// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"ed1531c4","82":"99f34537","136":"31246ff3","190":"bd4dba9c","233":"7a0bb370","330":"f575d4d3","369":"b4124021","468":"61bd0ae0","473":"0a683940","564":"b252af25","696":"52fff76e","770":"71999353","809":"1865d8dc","944":"44f8d24f"}[chunkId] + ".chunk.js";
};